<ng-container *ngIf="loading; else load">
    <app-loading></app-loading>
</ng-container>
<ng-template #load>
    <div mat-dialog-title class="toolbar toolbar-row">
        <span>{{'COMMON.BE_CALLED' | translate}}</span>
    </div>
    <div mat-dialog-content>
        <p>{{'COMMON.ASK_TO_BE_CALLED' | translate}}</p>
        <form [formGroup]="form">
            <div class="col-md-4">
                <mat-form-field class="full-width">
                    <mat-label>{{'COMMON.USER_INFO.FIRST_NAME' | translate}}</mat-label>
                    <input matInput formControlName="firstName" dividerColor="accent" class="full-width" required>
                </mat-form-field>
            </div>
            <div class="col-md-4">
                <mat-form-field class="full-width">
                    <mat-label>{{'COMMON.USER_INFO.LAST_NAME' | translate}}</mat-label>
                    <input matInput formControlName="lastName" dividerColor="accent" class="full-width" required>
                </mat-form-field>
            </div>
            <div class="col-md-4">
                <mat-form-field class="full-width" floatLabel="always">
                    <mat-label>{{'COMMON.USER_INFO.PHONE_NUMBER' | translate}}</mat-label>
                    <app-phone formControlName="phoneNumber" [required]="true"></app-phone>
                    <mat-error *ngIf="form.get('phoneNumber').hasError('required')">
                        {{'REGISTRATION.FORM.FIELD_MANDATORY' | translate: {fieldName: ('COMMON.USER_INFO.PHONE_NUMBER'
                        | translate)} }}
                    </mat-error>
                    <mat-error *ngIf="form.get('phoneNumber').hasError('isValidNumber')">
                        {{'REGISTRATION.FORM.PHONE_NUMBER_FORMAT' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </form>
    </div>
    <div mat-dialog-actions align="end">
        <button mat-raised-button (click)="close()">{{'COMMON.CLOSE'|translate}}</button>
        <button mat-raised-button color="primary" [disabled]="form.invalid" (click)="askToBeCalled()">{{'COMMON.CONFIRM'
            |translate}}</button>
    </div>
</ng-template>